import { useCallback, useContext, useEffect, useState } from "react";
import axios from "../../../../api/axios";
import { sleep } from "../../../../functions";
import RewardsContext from "./context";
import { useNavigate } from "react-router-dom";
import useAlert from "../../../../globalComponents/useAlerts";

export const useRewardsManager = () => {
  const { showLoading, showAlert, showConfirmDialog, dismissLoading } =
    useAlert();
  const navigate = useNavigate();
  const [request, setRequest] = useState({
    loading: true,
    data: [],
    page: 0,
    limit: 100,
  });

  const removeReward = (groupCode, quantity) => {
    const fn = async () => {
      try {
        showLoading();

        const data = await axios.delete("/rewards", {
          data: { groupCode, quantity },
        });

        if (!data)
          throw new Error(
            "Não foi possível remover prêmios. Verifique os parâmetros e tente novamente!",
          );

        dismissLoading();
        await getRewards();
      } catch (err) {
        showAlert({ title: "Atenção", description: err.message });
      }
    };

    showConfirmDialog({
      title: "Atenção",
      description: `Tem certeza que deseja remover ${quantity} prêmio(s)? A operação não poderá ser desfeita!`,
      onConfirm: fn,
    });
  };

  const getRewards = useCallback(async () => {
    const mData = { ...request };
    try {
      request.loading = true;
      //showLoading();
      const { data: response, error } = await axios.get(
        `/rewards?&page=${request.page + 1}&limit=${request.limit}`,
      );

      if (error) throw new Error(error);

      const formattedData = response.data.map(({ ...p }, index) => ({
        ...p,
        id: p._id,
        date: new Date(p.createdAt).toLocaleString(),
        updatedAt: new Date(p.updatedAt).toLocaleString(),
        showDetails: () => navigate(`./${p.groupCode}`),
        removeOne: () => removeReward(p.groupCode, 1),
        removeAll: () => removeReward(p.groupCode, p.quantity),
      }));

      Object.assign(mData, { ...response, data: formattedData });
    } catch (e) {
      console.log(e);
      mData.data = [];
    } finally {
      mData.loading = false;
      await sleep(1000);
      setRequest(mData);
    }
  }, [request.page, request.limit]);

  const onNextPage = ({ page, pageSize }) => {
    if (request.loading) return;
    setRequest((o) => ({ ...o, page, loading: true, limit: pageSize }));
  };

  useEffect(() => {
    async function fetchdata() {
      return getRewards();
    }

    fetchdata();
    return () => {};
  }, [getRewards]);

  return {
    request,
    getRewards,
    onNextPage,
  };
};

export const useRewards = () => useContext(RewardsContext);
